
import { languages, countries } from "@/config/localization"; // Corrected path

export const appLanguages = [...languages].sort((a, b) => a.name.localeCompare(b.name));
export const appCountries = [...countries].sort((a, b) => a.name.localeCompare(b.name));

export const getLanguageNameByCode = (code: string): string => {
  return appLanguages.find(lang => lang.code === code)?.name || code;
};

export const getCountryNameByCode = (code: string): string => {
  return appCountries.find(country => country.code === code)?.name || code;
};

// New helper functions for search functionality
export const getLanguageByName = (name: string) => {
  return appLanguages.find(lang => lang.name === name);
};

export const getCountryByName = (name: string) => {
  return appCountries.find(country => country.name === name);
};

// Search functions for alias matching
export const searchLanguages = (query: string) => {
  if (!query.trim()) return appLanguages;
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return appLanguages.filter(lang => 
    lang.name.toLowerCase().includes(normalizedQuery) ||
    lang.aliases.some(alias => alias.toLowerCase().includes(normalizedQuery))
  );
};

export const searchCountries = (query: string) => {
  if (!query.trim()) return appCountries;
  
  const normalizedQuery = query.toLowerCase().trim();
  
  return appCountries.filter(country => 
    country.name.toLowerCase().includes(normalizedQuery) ||
    country.aliases.some(alias => alias.toLowerCase().includes(normalizedQuery))
  );
};
